<template>
    <div class="acomodar">        
        <Registrador/>
    </div>
</template>

<script>
import Registrador from '@/components/ModSeleccion/Acceso/RegistrarAcceso.vue'
import '@/assets/styles/global-acomodar.css'; // Importar el estilo global
export default {
    name: 'SolimanologAccesoRegistrar',
    components:{
        Registrador
    },

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
};
</script>

